import React, { useEffect } from 'react';
import { Modal } from '@encarpkg/design';
import { Enlog } from '@encarpkg/shared';
import TranslateGuide from 'app/components/export/ExportTranslateGuide/TranslateGuide';

function ExportTranslateGuide({ handleClose, handleConfirm }) {
	useEffect(() => {
		Enlog().enloggingJsonData({
			dataTalkViewSingle: {
				eventNameGroup: '언어변경가이드',
			},
		});
	}, []);

	return (
		<Modal.V2Renew
			isOpen
			useDimClickClose={false}
			onClose={handleClose}
			title={
				<>
					Please use the browser’s
					<br />
					translation menu
				</>
			}
			buttonModuleProps={{
				okButtonProps: {
					children: 'Confirm & View Report',
					onClick: handleConfirm,
					'data-enlog-dt-eventname': 'confirm',
					'data-enlog-dt-eventnamegroup': '언어변경가이드',
				},
			}}
			textLinkModuleType="inside"
			textLinkModuleProps={{
				textLinkOneProps: {
					children: 'Stop showing this today',
					onClick: handleClose,
					'data-enlog-dt-eventname': 'stopshowing',
					'data-enlog-dt-eventnamegroup': '언어변경가이드',
				},
			}}
		>
			<TranslateGuide />
		</Modal.V2Renew>
	);
}

export default ExportTranslateGuide;
